/**
 * Shows a loading status if `isLoading` prop is true or renders the children if `isLoading` is false.
 */

import SVLoadingIndicator from '@pkgs/shared-client/components/SVLoadingIndicator';

const SVLoadingWrapper = ({
	isLoading,
	children,
	size,
}: {
	isLoading: boolean;
	children: () => JSX.Element | null;
} & Pick<React.ComponentProps<typeof SVLoadingIndicator>, 'size'>) => {
	if (isLoading) {
		return <SVLoadingIndicator size={size} />;
	}

	return children();
};

export default SVLoadingWrapper;
